import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';


@Component({
  selector: 'app-error-modal',
  imports: [],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
constructor(
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string, errorCode: number },
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ErrorModalComponent>, private authService: AuthService,
  ) {}

  closeModal() {

    if(this.data?.errorMessage == 'Session Expired'){

      this.dialogRef.close();

      this.authService.logout();

    }else{

      this.dialogRef.close();

    }

  }


  ngOnInit(): void {


  }
}
